import { HttpService } from '../http.service'

const http = new HttpService()

export interface Changes {
  field: string
  oldValue: string
  newValue: string
}

export interface AuditData {
  date: string
  user: string
  context: string
  action: string
  changes: Changes[]
}

export async function getAuditData(
  entityId: string,
  entityForm: string
): Promise<AuditData[]> {
  try {
    const response: any = await http.post('/audit', {
      id: entityId,
      entityForm
    })
    return response?.data
  } catch (error: any) {
    return []
  }
}
